module.exports = __webpack_public_path__ + "img/icon_9.25b6f735.png";